import { PortfolioEvmTokens } from './portfolio-evm-svm-tokens'

export const PortfolioTokens = () => {
  return (
    <div className="flex flex-col h-full gap-y-5">
      <PortfolioEvmTokens />
    </div>
  )
}
